import { ref } from '@vue/composition-api';
import { sessionService } from '@/bundles/Session/factory/SessionServiceFactory.ts';

export function useSession() {
  const session = ref<any[]>([]);
  const total = ref(0);
  const pending = ref(false);

  async function fetch(params: any[]) {
    pending.value = true;
    const response = await sessionService.list(params);
    session.value = response.data;
    total.value = response.total;
    pending.value = false;
  }

  return {
    session,
    total,
    pending,
    fetch,
  };
}
